module.exports = require('./assign');



/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/~/lodash/object/extend.js
 ** module id = 222
 ** module chunks = 0
 **/